import { render } from "./AllSegmentGroupsMigrationTable.vue?vue&type=template&id=35ec0366&scoped=true"
import script from "./AllSegmentGroupsMigrationTable.vue?vue&type=script&lang=js"
export * from "./AllSegmentGroupsMigrationTable.vue?vue&type=script&lang=js"

import "./AllSegmentGroupsMigrationTable.vue?vue&type=style&index=0&id=35ec0366&lang=scss&scoped=true"
import "./AllSegmentGroupsMigrationTable.vue?vue&type=style&index=1&id=35ec0366&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35ec0366"]])

export default __exports__